<template>
	<div class="agent-marketing-block">
		<LoginWrapper :wider="true">
			<b-container class="mt-3">
			<!-- HERO (moved out from form block) -->
			<div v-if="!successRegistration" class="mb-4">
				<b-card class="agent-hero" body-class="p-4 p-md-5">
					<div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
						<div class="mb-3 mb-md-0 text-white">
							<div class="mb-3">
								<div class="mb-3">
									<img src="/img/logo-tanasoft.svg" alt="TanaSoft" class="white-logo" />
								</div>
								<h2 class="mb-0 mt-4 text-white-80">Работайте удаленно <br />и зарабатывайте вместе с нами</h2>
							</div>
							<p class="lead mb-0 lead-gray">Станьте агентом компании ТАНАИС прямо сейчас!<br />
							Получайте стабильный доход!<br />
							Работайте когда и где удобно!</p>
						</div>
                    <div style="max-width: 400px;">
                        <!-- <b-badge pill variant="light" class="hero-badge mb-3" title="Выплачиваем сразу же после первой удачной сделки">🎁 +5000 приветственных рублей  </b-badge> -->
                        <!-- <b-badge pill variant="warning" class="hero-badge mb-3" title="Клиент закрепляется за вами на 1 год">💰 30% с прибыли пока вы с нами  </b-badge> -->
                        <div :class="$mq == 'sm' ? 'mt-2' : 'mt-5'">
                            <b-button size="lg" class="btn-cta-hero" @click="scrollToForm">
                                <b-icon icon="chevron-double-down" class="mr-2 icon-down" scale="1.1"></b-icon>
                                Стать агентом
                            </b-button>
                        </div>
                    </div>
					</div>
				</b-card>
			</div>

			<!-- BENEFITS (moved out) -->
			<!-- <b-row v-if="!successRegistration" class="mb-4">
				<b-col cols="12" md="4" class="mb-3">
					<b-card class="benefit-card h-100">
						<div class="benefit-emoji">🌍</div>
						<div class="benefit-title">Свободный график</div>
						<div class="benefit-text">Работайте из любой точки мира — достаточно интернета</div>
					</b-card>
				</b-col>
				<b-col cols="12" md="4" class="mb-3">
					<b-card class="benefit-card h-100">
						<div class="benefit-emoji">🤝</div>
						<div class="benefit-title">Мы — ваш бэк-офис</div>
						<div class="benefit-text">Закрываем операционку по поставкам и документам</div>
					</b-card>
				</b-col>
				<b-col cols="12" md="4" class="mb-3">
					<b-card class="benefit-card h-100">
						<div class="benefit-emoji">🚀</div>
						<div class="benefit-title">Быстрый старт</div>
						<div class="benefit-text">Регистрация — проверка — первые выплаты уже в этом месяце</div>
					</b-card>
				</b-col>
			</b-row> -->

			<!-- STEPS (moved out) -->
			<b-card v-if="!successRegistration" class="mb-4 steps-card pl-4 pr-4">
				<div class="steps-title mb-3">Как это работает</div>
				<b-row>
					<b-col cols="12" md="3" class="mb-3">
						<div class="step-item">
							<div class="step-num">1</div>
							<div class="step-text">Заполните форму регистрации</div>
						</div>
					</b-col>
					<b-col cols="12" md="3" class="mb-3">
						<div class="step-item">
							<div class="step-num">2</div>
							<div class="step-text">Пройдите короткую проверку</div>
						</div>
					</b-col>
					<b-col cols="12" md="3" class="mb-3">
						<div class="step-item">
							<div class="step-num">3</div>
							<div class="step-text">Приводите клиентов и совершайте сделки</div>
						</div>
					</b-col>
					<b-col cols="12" md="3" class="mb-3">
						<div class="step-item">
							<div class="step-num">4</div>
							<div class="step-text">Получайте выплаты на карту или в банк</div>
						</div>
					</b-col>
				</b-row>
			</b-card>	
		</b-container>

		<div 
			v-if="!successRegistration"
			class="login-form__title"
			id="agent-register-form"
		>Заполните форму регистрации</div>

			<div class="login-form form-bold-labels pb-4">
				<b-jumbotron 
					v-if="successRegistration"
					class="mt-4"
				>
					<template #header>
						<h3 class="display-6">
							Регистрация прошла успешно!
						</h3>
					</template>

					<template #lead >
						<div style="margin-top: 35px;">
							Спасибо, что присоединились к нашей команде.<br />
							Теперь необходимо войти в Ваш аккаунт!
						</div>
					</template>
				
					<hr class="my-4">
				
					<p class="text-right">
						<b-button
							variant="success"
							size="lg"
							class="btn-cta-register"
							@click="gotToLogin()"
						>
							Войти в аккаунт &raquo;
						</b-button>
					</p>
				</b-jumbotron>            

                <b-form 
					v-if="!successRegistration"
					@submit.prevent="registerAgent"
                >
					<!-- ФИО -->
					<b-row>
						<b-col sm="12" md="4">
							<b-form-group label="Фамилия">
								<b-form-input v-model="form.last_name" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="12" md="4">
							<b-form-group label="Имя">
								<b-form-input v-model="form.first_name" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="12" md="4">
							<b-form-group label="Отчество">
								<b-form-input v-model="form.middle_name"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- Email и Телефон -->
					<b-row>
						<b-col sm="12" md="6">
							<b-form-group label="Email">
								<b-form-input
									v-model="form.email"
									type="email"
									required
									placeholder="example@domain.com"
									:state="emailValid"
								></b-form-input>
								<b-form-invalid-feedback>Введите корректный Email</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<b-col sm="12" md="6">
							<b-form-group label="Телефон">
								<b-form-input
									v-model="form.phone"
									required
									placeholder="+7XXXXXXXXXX"
									@input="formatPhone"
									:state="phoneValid"
								></b-form-input>
								<b-form-invalid-feedback>Введите номер в формате +7XXXXXXXXXX</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- Пароль и Подтверждение -->
					<b-row>
						<b-col sm="12" md="6">
							<b-form-group label="Пароль">
								<b-input-group>
									<b-form-input
										:type="passwordVisible ? 'text' : 'password'"
										v-model="form.password"
										required
										autocomplete="new-password"
										@input="checkPasswordStrength"
									></b-form-input>
									<b-input-group-append is-text @click="passwordVisible = !passwordVisible" style="cursor: pointer;">
										<b-icon :icon="passwordVisible ? 'eye-slash' : 'eye'"></b-icon>
									</b-input-group-append>
								</b-input-group>

								<ul class="mt-2 password-rules">
									<li :class="{'text-success': passwordRules.length, 'text-danger': !passwordRules.length}">Минимум 8 символов</li>
									<li :class="{'text-success': passwordRules.uppercase, 'text-danger': !passwordRules.uppercase}">Хотя бы одна заглавная буква</li>
									<li :class="{'text-success': passwordRules.digit, 'text-danger': !passwordRules.digit}">Хотя бы одна цифра</li>
									<li :class="{'text-success': passwordRules.special, 'text-danger': !passwordRules.special}">Хотя бы один спецсимвол (!@#$%^&*)</li>
								</ul>
							</b-form-group>
						</b-col>

						<b-col sm="12" md="6">
							<b-form-group label="Подтверждение пароля">
								<b-input-group>
									<b-form-input
										:type="confirmPasswordVisible ? 'text' : 'password'"
										v-model="form.password_confirmation"
										@input="passwordMismatch = form.password !== form.password_confirmation ? true : false"
										required
									></b-form-input>
									<b-input-group-append is-text @click="confirmPasswordVisible = !confirmPasswordVisible" style="cursor: pointer;">
										<b-icon :icon="confirmPasswordVisible ? 'eye-slash' : 'eye'"></b-icon>
									</b-input-group-append>
								</b-input-group>
								<b-form-invalid-feedback v-if="passwordMismatch" class="d-block">Пароли не совпадают</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- Тип агента -->
					<b-form-group label="Выберите тип агента">
						<b-form-radio-group v-model="form.agent_company_type" :options="typeOptions" required />
					</b-form-group>

					<!-- Опыт в логистике -->
					<b-form-group label="Укажите ваш опыт в логистике">
						<b-form-radio-group v-model="form.is_logistics_beginner" :options="logisticsExperienceOptions" required />
					</b-form-group>

					<!-- Согласия -->
					<b-form-group label="Для регистрации необходимо Ваше согласие с нашими условиями">
						<div class="d-flex align-items-start">
							<b-form-checkbox 
								v-model="form.agree_confidential" 
								required
								class="mt-1 mr-2"
							></b-form-checkbox>
							<div class="flex-grow-1" style="padding-top: 4px; margin-left: -5px;">
								Я принимаю <a href="#" class="text-primary" @click.prevent.stop="openPrivacyModal">Политику обработки ПД</a>
							</div>
						</div>
					</b-form-group>

					<!-- Согласие на обработку персональных данных -->
					<b-form-group label="Согласие на обработку персональных данных">
						<ConcentPersonalData 
							@consent-scrolled="onConsentScrolled"
							:rows="7"
							:userData="form"
						/>
					</b-form-group>

					<!-- Кнопка -->
                    <div class="text-center mt-4 mb-4">
                        <b-button 
                            type="submit" 
                            size="lg"
                            class="btn-cta-register mt-2"
                            :disabled="loading || !consentScrolled"
                        >
                            <b-icon icon="person-plus" class="mr-2"></b-icon>
                            <span>Зарегистрироваться</span>
                            <i class="fas fa-spinner fa-spin ml-2" v-if="loading"></i>
                        </b-button>

						<div class="text-center mt-3">
							<b-link :to="'/login'" class="text-primary">« Вход для агентов</b-link>
						</div>
                    </div>
				</b-form>
			</div>
		</LoginWrapper>

		<!-- Модальное окно политики конфиденциальности -->
		<PrivacyPolicyModal
			:visible.sync="showPrivacyModal"
		/>
	</div>
</template>

<script>
	import LoginWrapper from "@components/login/LoginWrapper.vue";
	import LoginLogo from "@components/login/LoginLogo.vue";
	import PrivacyPolicyModal from "@components/agent/PrivacyPolicyModal.vue";
	import ConcentPersonalData from "@components/agent/ConcentPersonalData.vue";
	import { API_AGENT_REGISTRATION } from '@/constants';

	export default {
		components: { LoginWrapper, LoginLogo, PrivacyPolicyModal, ConcentPersonalData },
		data() {
			return {
                loading: false,
                successRegistration: false,
                showPrivacyModal: false,
				form: {
					last_name: '',
					first_name: '',
					middle_name: '',
					email: '',
					phone: '',
					password: '',
					password_confirmation: '',
					role: 'agent',
					agree_confidential: false,
					agent_company_type: '',
					is_logistics_beginner: true
				},
				consentScrolled: false,


				passwordVisible: false,
				confirmPasswordVisible: false,
				passwordMismatch: false,
				passwordRules: {
					length: false,
					uppercase: false,
					digit: false,
					special: false
				},
				typeOptions: [
					{ text: 'Индивидуальный предприниматель (ИП)', value: 'ip' },
					{ text: 'Физическое лицо', value: 'fiz' }
				],
				logisticsExperienceOptions: [
					{ text: 'Новичок в логистике', value: true },
					{ text: 'Имею опыт в логистике', value: false }
				]
			};
		},
		computed: {
			phoneValid() {
				return /^\+7\d{10}$/.test(this.form.phone);
			},
			emailValid() {
				return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.form.email);
			}
		},

		methods: {
            scrollToForm() {
                try {
                    const el = this.$el.querySelector('#agent-register-form');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } catch (e) {}
            },
			formatPhone() {
				this.form.phone = this.form.phone.replace(/[^+\d]/g, '');
			},
			checkPasswordStrength() {
				const pwd = this.form.password;
				this.passwordRules.length = pwd.length >= 8;
				this.passwordRules.uppercase = /[A-ZА-Я]/.test(pwd);
				this.passwordRules.digit = /\d/.test(pwd);
				this.passwordRules.special = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(pwd);
			},
            async registerAgent() {
                this.passwordMismatch = false;

                // Проверка галочки
                if (!this.form.agree_confidential) {
                    this.$bvToast.toast('Необходимо принять политику обработки ПД', {
                        variant: 'danger',
                        title: 'Ошибка заполнения формы'
                    });
                    return;
                }

                // Проверка прокрутки согласия
                if (!this.consentScrolled) {
                    this.$bvToast.toast('Необходимо полностью прокрутить текст согласия на обработку ПД', {
                        variant: 'danger',
                        title: 'Ошибка заполнения формы'
                    });
                    return;
                }

                // Валидация Email и телефона
                if (!this.phoneValid || !this.emailValid) {
                    this.$bvToast.toast('Проверьте Email и телефон', { variant: 'danger', title: 'Ошибка заполнения формы' });
                    return;
                }

                // Проверка сложности пароля
                if (Object.values(this.passwordRules).includes(false)) {
                    this.$bvToast.toast('Пароль не соответствует требованиям', { variant: 'danger', title: 'Ошибка заполнения формы' });
                    return;
                }

                // Обязательные поля
                const requiredFields = ['last_name', 'first_name', 'email', 'phone', 'password', 'password_confirmation', 'agent_company_type', 'is_logistics_beginner'];
                for (const field of requiredFields) {
                    if (this.form[field] === null || this.form[field] === undefined || this.form[field] === '') {
                        this.$bvToast.toast('Заполните все обязательные поля', { variant: 'danger', title: 'Ошибка заполнения формы' });
                        return;
                    }
                }

                // Проверка совпадения паролей
                if (this.form.password !== this.form.password_confirmation) {
                    this.passwordMismatch = true;
                    this.$bvToast.toast('Пароли не совпадают', { variant: 'danger', title: 'Ошибка заполнения формы' });
                    return;
                }

                this.loading = true;

                const formData = new FormData();
                formData.append('name', `${this.form.last_name} ${this.form.first_name} ${this.form.middle_name}`.trim());

                ['email', 'phone', 'password', 'password_confirmation', 'role', 'agent_company_type', 'agree_confidential', 'is_logistics_beginner'].forEach(field => {
                    formData.append(field, this.form[field]);
                });

                // Добавляем данные о согласиях (только если согласия даны)
                if (this.form.agree_confidential) {
                    formData.append('privacy_policy_accepted', 'true');
                }
                if (this.consentScrolled) {
                    formData.append('personal_data_consent_scrolled', 'true');
                }

                try {
                    await api.call('post', API_AGENT_REGISTRATION, formData);

                    this.successRegistration = true;
                    this.loading = false;
                } catch (err) {
                    this.loading = false;
                    // Ошибки теперь обрабатываются глобально в axios interceptor
                    // Дополнительная обработка здесь не нужна
                }
            },
            gotToLogin() {
                this.$router.push("/login");
            },
            openPrivacyModal() {
                this.showPrivacyModal = true;
            },
            onConsentScrolled(scrolled) {
                this.consentScrolled = scrolled;
            },


		}
	};
</script>

<style scoped>
.password-rules {
    margin-left: 25px;
    list-style: disc;
    font-size: 12px;
    line-height: 15px;
}

.white-logo {
	width: 100%;
	max-width: 335px;
	height: auto;
    filter: brightness(0) invert(1);
}

@media (max-width: 768px) {
    .white-logo {
        max-width: 223px;
    }

	h2 {
		font-size: 1.2rem;
	}

	.lead-gray {
		font-size: 1rem;
	}

	.hero-badge {
		font-size: 0.8rem;
	}
}

</style>